export const SalesList = ({ sales }) => {
  if (sales.length === 0) return null;
  return (
    <>
      <h2 className="font-serif-display text-3xl font-light mt-20 mb-6">Recent Sales</h2>
      <div className="border border-[#E5E0D8]">
        {sales.map((s) => (
          <div key={s.id} className="flex justify-between p-4 border-b border-[#E5E0D8] last:border-b-0">
            <span className="text-sm">{s.buyer_email}</span>
            <span className="font-mono-aam text-sm">${s.amount.toLocaleString()}</span>
          </div>
        ))}
      </div>
    </>
  );
};
